import axios from 'axios'
import camelcaseKeys from 'camelcase-keys'

import { redirectLogin } from '@/utils/idaas'

const instance = axios.create({
  timeout: 10 * 1000
})

instance.interceptors.response.use(response => {
  const data = response.data
  if (data.error) {
    const apiError = data.error
    // 如果是未登录或者登录过期，跳转到指定的地址
    if (apiError.code === 100 && apiError.ssourl) {
      redirectLogin(apiError.ssourl)
      // 如果是认证问题，返回一个 pending 状态的 Promise，阻止后续的动作发生，避免产生异常被 Sentry 捕捉
      return new Promise(() => {})
    }
    const error = new Error(apiError.message)
    throw Object.assign(error, apiError)
  }

  const result = response.data.result || response.data
  response = camelcaseKeys(result, {
    deep: true
  })

  return response
}, error => {
  return Promise.reject(error)
})

export default instance
